/* eslint-disable no-unreachable */
/* eslint-disable @typescript-eslint/no-unused-vars */
import BreadCrumb from 'Components/Common/BreadCrumb';
import CommonModal from 'Components/Common/CommonModal';
import { ADMIN_ADD_ROLE_FORMSCHEMA, ADMIN_ADD_USER_FORM_SCHEMA, PhoneNumberCodes } from 'Components/Common/FormSchemas/FormSchema';
import TableContainer from 'Components/Common/TableContainer';
import { ROLES_TABLE_SCHEMA } from 'Components/Common/TableSchemas/TableSchemas';
import { filterValidParams, generateInitialValues, generateValidationSchema, trimValues } from 'Components/Common/Util';
import Checkbox from 'Components/DynamicComponents/Checkbox';
import DropzoneComponent from 'Components/DynamicComponents/DropzoneComponent';
import InputComponent from 'Components/DynamicComponents/InputComponent';
import SelectComponent from 'Components/DynamicComponents/SelectComponent';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { Button, Card, CardBody, Col, Container, Input, Row } from 'reactstrap';
import * as Yup from 'yup';
import * as url from '../../../src/helpers/url_helper';

import { departments, rolePrivilegesMap } from '../../../src/Components/constants/appConstants';
import withRouter from 'Components/Common/withRouter';
import { toast } from 'react-toastify';
import DeleteModal from 'Components/Common/DeleteModal';
import InputGroupComponent from 'Components/DynamicComponents/InputGroupComponent';
import toastMessages from 'Components/Common/messages/toastMessages';
import Loader from 'Components/Common/Loader';
import { useSelector } from 'react-redux';
import { useDepartmentSchema } from './useDepartmentSchema';

const EditUser = (props: any) => {
    const api = props?.router?.apiClient;

    const recordID = window.location.hash?.split('/')?.reverse()?.[0];

    const [formSchema, setFormSchema] = useState<any>(ADMIN_ADD_USER_FORM_SCHEMA);
    const [addRoleFormSchema, setAddRoleFormSchema] = useState<any>(() => JSON.parse(JSON.stringify(ADMIN_ADD_ROLE_FORMSCHEMA)));
    const [tableSchema, setTableSchema] = useState<any>(ROLES_TABLE_SCHEMA);
    const [rolesData, setRolesData] = useState<any>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [selectedRole, setSelectedRole] = useState<string>('');

    const [isRoleModelOpen, setIsRoleModelOpen] = useState<boolean>(false);
    const [isDeleteModelOpen, setIsDeleteModelOpen] = useState<boolean>(false);
    const [selectedRow, setSelectedRow] = useState<any>({});

    const [privilege, setPrivilege] = useState(false);
    const [profileUrl, setProfileUrl] = useState<any>([]);
    const [selectedOption, setSelectedOption] = useState<any>();
    const [modeOfRole, setModeOfRole] = useState<string>('add');

    const [userData, setUserData] = useState<any>({});

    const [modelLoading, setModelLoading] = useState<any>(false);

const departmentOptions = useSelector(
  (state: any) => state.Login.departmentOptions
);
    //department options hook
      useDepartmentSchema(formSchema, "value");

    const EditUserValidation: any = useFormik({
        enableReinitialize: true,
        initialValues: generateInitialValues(formSchema),
        validationSchema: generateValidationSchema(formSchema, Yup, selectedOption),
        validate: (values) => trimValues(values, formSchema),
        onSubmit: (values) => {
            const editPayLoad = {
                userRef: userData.userRef,
                empId: values?.empId,
                firstName: values?.firstName,
                lastName: values?.lastName,
                email: values?.email,
                phoneNumber: {
                    code: values?.phoneExtension?.value,
                    value: values?.phoneNumber
                },
                // department: values?.department?.value?.toLowerCase() === 'other' ? values?.otherDepartment : values?.department?.value,
                department:values?.department?.label,
                address: values?.address,
                profileImage: values?.profile?.[0]?.fileName,
                userProfile: {
                    roles: (Array.isArray(rolesData) ? rolesData : []).map((role: any) => {
                        const { roleId, roleName, privileges = [], areasData, minesData } = role;

                        return {
                            roleId,
                            role: roleName?.replaceAll(' ', '_')?.toUpperCase(),
                            privileges,
                            areaIds: (Array.isArray(areasData) ? areasData : []).map((area: any) => {
                                const { areaRef, areaName, value, label } = area;

                                const filteredMines = (Array.isArray(minesData) ? minesData : [])
                                    .filter((mine: any) => (mine?.areaId || '')?.toLowerCase() === (areaRef || '')?.toLowerCase())
                                    .map((mine: any) => ({
                                        mineRef: mine?.mineRef ?? '',
                                        mineName: mine?.mineName ?? '',
                                        areaId: mine?.areaId ?? ''
                                    }));

                                return {
                                    areaRef: areaRef ?? value ?? '',
                                    areaName: areaName ?? label ?? '',
                                    mines: filteredMines
                                };
                            })
                        };
                    })
                }
            };

            const validData = filterValidParams(editPayLoad);
            setLoading(true);
            api.create(url?.CREATE_USER, editPayLoad)
                .then((res: any) => {
                    if (res?.status?.toLowerCase() === 'success') {
                        // navigate to the users screen, reset form , toast message, reset the rolesData
                        props?.router?.navigate('/user-management');
                        EditUserValidation?.resetForm();
                        setRolesData([]);
                        // toast.success(toastMessages?.userAdded);
                        toast.success(res?.data?.message);
                        setLoading(false);
                    } else {
                        setLoading(false);
                    }
                })
                .catch((err: any) => setLoading(false));
        }
    });

    const filteredRoleFormSchema = addRoleFormSchema?.filter((schema: any) => schema?.value !== 'heading');
    const addRoleValidation: any = useFormik({
        enableReinitialize: false,
        initialValues: generateInitialValues(filteredRoleFormSchema),
        validationSchema: generateValidationSchema(filteredRoleFormSchema, Yup),
        validate: (values) => trimValues(values, filteredRoleFormSchema),
        onSubmit: (values) => {
            const newRoleId = values?.role?.id;
            const newRoleName = values?.role?.value?.toLowerCase();

            // Prepare transformed data
            const areasList = Array.isArray(values?.areas) ? values.areas.map((area: any) => area?.areaRef) : [];
            const minesList = Array.isArray(values?.mines) ? values.mines.map((mine: any) => mine?.mineRef) : [];

            const privileges = addRoleFormSchema
                .filter((item: any) => item.inputType === 'checkbox' && addRoleValidation?.values?.[item.value])
                .map((item: any) => item.value);

            if (modeOfRole?.toLowerCase() === 'add') {
                // Check for duplicate role by ID or name
                const isDuplicate = rolesData.some(
                    (role: any) =>
                        role.roleId === newRoleId ||
                        role.roleName?.replaceAll('_', ' ')?.toLowerCase() === newRoleName?.replaceAll('_', ' ')?.toLowerCase()
                );

                if (isDuplicate) {
                    toast.error(`Role with the same ID ${newRoleId} or name ${newRoleName} already exists`);
                    return;
                }

                // Update state
                setRolesData((prevRoles: any) => [
                    ...prevRoles,
                    {
                        roleId: newRoleId,
                        roleName: values?.role?.value,
                        areasData: values?.areas,
                        minesData: values?.mines,
                        regionsData: values?.regions || [],
                        areasCount: areasList.length,
                        minesCount: minesList.length,
                        privilegesCount: privileges.length,
                        privileges,
                        areasList: values?.areas || [],
                        minesList: values?.mines || []
                    }
                ]);

                // Close modal and reset form
                setIsRoleModelOpen(false);
                addRoleValidation.resetForm();
                setPrivilege(false);
                toast.success('Role Added Successfully');
            } else if (modeOfRole === 'edit') {
                // api will be here only

                const editedRole = {
                    roleId: newRoleId,
                    roleName: values?.role?.value,
                    areasData: values?.areas,
                    minesData: values?.mines,
                    regionsData: values?.regions || [],
                    areasCount: areasList.length,
                    minesCount: minesList.length,
                    privilegesCount: privileges.length,
                    privileges,
                    areasList: values?.areas || [],
                    minesList: values?.mines || []
                };

                // update state
                setRolesData((prevRoles: any) =>
                    prevRoles?.map((roleItem: any) => {
                        if (roleItem?.roleId === newRoleId) {
                            return editedRole;
                        }
                        return roleItem;
                    })
                );

                // Close modal and reset form
                setIsRoleModelOpen(false);
                addRoleValidation.resetForm();
                setPrivilege(false);
                toast.success(`Role with ID ${newRoleId} or Name ${values?.role?.value} Updated Successfully`);
            }
        }
    });

    useEffect(() => {
        if (recordID) {
            const filterPayload = {
                textSearch: '',
                userRef: recordID
            };

            const filters = filterValidParams(filterPayload);

            const payLoad = {
                params: {
                    search: JSON.stringify(filters),
                    page: 1,
                    size: 1
                }
            };
            setLoading(true);
            api.get(`${url?.GET_USERS}`, payLoad)
                .then(async (resp: any) => {
                    if (resp?.status?.toLowerCase() === 'success' && resp?.data) {
                        const userData = resp?.data?.data?.[0];
                        setUserData(userData);



                        let val = departmentOptions?.find((each: any) => each?.name === userData?.department) || {}

                        formSchema?.forEach((schema: any) => {
                        if (schema?.value?.toLowerCase() === 'email') {
                                schema.disabled = true;
                            }
                        });
                        // image related properties
                        const preview = userData?.profileImage ?? null;
                        const fileArray = userData?.profileImage ? userData.profileImage.split('/') : [];
                        const fileName = fileArray.length > 0 ? fileArray[fileArray.length - 1] : '';

                        EditUserValidation?.setValues({
                            firstName: userData?.firstName,
                            lastName: userData?.lastName,
                            empId: userData?.empId,
                            email: userData?.email,
                            department: { label: val?.name, value: val?.name },
                            phoneNumber: userData?.phoneNumber?.value,
                            phoneExtension: PhoneNumberCodes?.find((item: any) => item?.value === userData?.phoneNumber?.code),
                            address: userData?.address,
                            profile: preview && fileName ? [{ preview, name: fileName, fileID: fileName, fileName }] : []
                            // profile: [{ preview, name: fileName, fileID: fileName, fileName }]
                        });

                        const roles = userData?.userProfile?.roles;
                        const rolesWithData = roles?.map((roleItem: any) => {
                            return {
                                ...roleItem,
                                roleId: roleItem?.roleId,
                                roleName: roleItem?.role,
                                privileges: roleItem?.privileges,
                                privilegesCount: roleItem?.privileges?.length,
                                areasData: roleItem?.areaIds,
                                minesData: roleItem?.areaIds?.flatMap((item: any) => item?.mines)?.filter(Boolean)
                            };
                        });

                        setRolesData(rolesWithData);
                        setLoading(false);
                    }
                    setLoading(false);
                })
                .catch(() => {
                    setLoading(false);
                });
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [recordID]);

    useEffect(() => {
        const basePrivileges: string[] = rolePrivilegesMap[selectedRole] || [];
        const checkedPrivileges = basePrivileges?.filter((baseItem: any) => addRoleValidation?.values[baseItem?.value]);
        setPrivilege(basePrivileges?.length === checkedPrivileges?.length);
    }, [addRoleValidation?.values, selectedRole]);

    const renderItems = (field: any, validation: any): JSX.Element | any => {
        switch (field.inputType) {
            case 'dropdown':
                return (
                    <div className="my-0">
                        <SelectComponent field={field} validation={validation} onChange={handleMainSelectChange}></SelectComponent>
                    </div>
                );
            case 'input':
                return (
                    <Col lg={12}>
                        <div className="my-0">
                            <InputComponent field={field} mode={'add'} validation={validation}></InputComponent>
                        </div>
                    </Col>
                );
            case 'inputgroup':
                return (
                    <div className={'my-0'}>
                        <InputGroupComponent
                            field={field}
                            validation={validation}
                            mode={''}
                            // eslint-disable-next-line multiline-comment-style
                            schemaRegex={validation.values.phoneExtension?.validationPattern || ''}
                            handlepattern={handleValidationPatternChange}
                        ></InputGroupComponent>
                    </div>
                );

            case 'upload':
                return (
                    <Col lg={12}>
                        <div className="my-0">{uploadComponent(field, validation)}</div>
                    </Col>
                );
        }
    };

    const handleValidationPatternChange = (option: any) => {
        setSelectedOption(option?.validationPattern); // Update the selected option when the dropdown value changes
    };

    const uploadComponent = (field: any, formValidation: any) => {
        return (
            <div className="my-0 mt-2">
                <div className="mx-1">
                    <label htmlFor={field.label}>{field.label}</label>{' '}
                    <span className="text-danger ps-1"> {field.mandatory ? '*' : ''}</span>
                    <DropzoneComponent
                        noOfFilesAccepted={field.noOfFiles || 1}
                        maxSize={field.fileSize || 5 * 1024 * 1024}
                        fieldName={field.value}
                        type={field.type}
                        accept={field.accept}
                        // accept={field.accept || 'application/vnd.openxmlformats-officedocument.spreadsheetml'}
                        files={formValidation.values[field.value] ? formValidation.values[field.value] : []}
                        handleOnChange={(event: any) => {
                            handleChangeFiles({
                                name: field.value,
                                value: event.target.files,
                                id: field.value,
                                action: event.target.action,
                                file: event.target.file
                            });
                            formValidation.handleChange({
                                target: {
                                    name: field.value,
                                    value: event.target.files,
                                    id: field.value
                                }
                            });
                        }}
                        onBlur={formValidation.handleBlur}
                        field={field}
                        values={{ uploadType: formValidation.values?.['type'] || '' }}
                        showHeader={false}
                        label={field.label}
                        isMultipleFiles={field.isMultifiles || false}
                        fileTypeMsg={field?.fileTypeMsg}
                        required={field.required || false}
                        disabled={field.isDisabled || false}
                        dropzoneheight={'20'}
                        handleDeleteFile={handleDeleteFile}
                    ></DropzoneComponent>
                    {formValidation.touched[field.value] && formValidation.errors[field.value] ? (
                        <p className="text-danger fs-12 pt-1">'is required'</p>
                    ) : null}
                </div>
            </div>
        );
    };

    const handleChangeFiles = (obj: any) => {
        if (obj.action !== 'DELETE') {
            const formData = new FormData();
            formData.append('file', obj.value[obj.value?.length - 1]);
            formData.append('folder', 'Profile');

            const file = obj.value[0];
            setLoading(true);
            api.uploadFile(url.UPLOAD_DOCUMENTS, formData)
                .then((res: any) => {
                    if (res.status?.toLowerCase() === 'success') {
                        toast.success(toastMessages.imageUploaded);

                        const fileData = res?.data;
                        const fileName = fileData?.filePath;
                        const fileArray = fileName?.split('/');
                        const fileID = fileArray?.[fileArray?.length - 1];
                        // const preview = url.UPLOAD_PRIEVIEW(fileID);
                        const preview = fileName;
                        // setProfileUrl([{ preview, name: fileName, formattedSize: file?.formattedSize, fileID, fileName }]);

                        EditUserValidation.setFieldValue('profile', [
                            { preview, name: fileName, formattedSize: file?.formattedSize, fileID, fileName }
                        ]);
                        setLoading(false);
                    } else {
                        setLoading(false);
                        toast.error('no matching header row found');
                    }
                })
                .catch((err: any) => {
                    setLoading(false);
                    toast.error(err?.message);
                });
        }
    };

    const handleDeleteFile = (fieldName: any, file: any, index: number) => {
        const filepath = file.preview;
        setLoading(true);
        api.deleteFile(`${url.DELETE_DOCUMENTS}/${filepath}`)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success') {
                    setLoading(false);
                    toast.success(resp?.data?.message);
                } else {
                    setLoading(false);
                }
            })
            .catch((e: any) => setLoading(false))
            .finally(() => {
                setLoading(false);
            });
    };

    const modelRenderItems = (field: any, validation: any): JSX.Element | any => {
        switch (field.inputType) {
            case 'dropdown':
                return (
                    <div className="my-0">
                        <SelectComponent field={field} validation={validation} onChange={handleSelectChange}></SelectComponent>
                    </div>
                );

            case 'checkbox':
                return (
                    <div className="my-0">
                        <Checkbox field={field} validation={validation} mode="" checked={validation?.values?.[field.value]} />
                    </div>
                );
            case 'heading':
                return (
                    <div className="my-0">
                        <div className="d-flex align-items-center">
                            <Input
                                type="checkbox"
                                name="privilege"
                                checked={privilege}
                                onChange={(e: any) => {
                                    const isChecked = e.target.checked;
                                    setPrivilege(isChecked);

                                    const updatedSchema = addRoleFormSchema.map((field: any) => {
                                        if (field.inputType === 'checkbox') {
                                            return { ...field, checked: isChecked };
                                        }
                                        return field;
                                    });

                                    // Update form schema state
                                    setAddRoleFormSchema(updatedSchema);

                                    // Update formik values
                                    const updatedValues = { ...addRoleValidation?.values };
                                    updatedSchema.forEach((field: any) => {
                                        if (field.inputType === 'checkbox') {
                                            updatedValues[field.value] = isChecked;
                                        }
                                    });

                                    addRoleValidation?.setValues(updatedValues);
                                }}
                                className="me-2 cursor-pointer"
                            />

                            <h4
                                className="font-size-18 font-weight-500 line-height-24 text-secondary my-3 cursor-pointer"
                                onClick={() =>
                                    setPrivilege((prev: boolean) => {
                                        const newVal = !prev;

                                        const updatedSchema = addRoleFormSchema.map((field: any) => {
                                            if (field.inputType === 'checkbox') {
                                                return { ...field, checked: newVal };
                                            }
                                            return field;
                                        });

                                        setAddRoleFormSchema(updatedSchema);

                                        const updatedValues = { ...addRoleValidation?.values };
                                        updatedSchema.forEach((field: any) => {
                                            if (field.inputType === 'checkbox') {
                                                updatedValues[field.value] = newVal;
                                            }
                                        });

                                        addRoleValidation?.setValues(updatedValues);
                                        return newVal;
                                    })
                                }
                            >
                                Privileges<span className="text-danger ps-1"> {'*'}</span>
                            </h4>
                        </div>
                    </div>
                );
        }
    };

    const handleMainSelectChange = (e: any) => {
        const target = e?.target?.name?.toLowerCase();
        const selectedItem = e.target.value?.value?.toLowerCase();
        // if (target === 'department') {
        //     EditUserValidation.setFieldValue('otherDepartment', '');
        //     if (selectedItem === 'other') {
        //         formSchema?.forEach((schema: any) => {
        //             if (schema?.value === 'otherDepartment') {
        //                 schema.mandatory = true;
        //                 schema.isVisible = true;
        //             }
        //         });
        //     } else {
        //         formSchema?.forEach((schema: any) => {
        //             if (schema?.value === 'otherDepartment') {
        //                 schema.mandatory = false;
        //                 schema.isVisible = false;
        //             }
        //         });
        //     }
        // }
    };

    const handleSelectChange = (e: any) => {
        const target = e?.target?.name?.toLowerCase();

        if (target === 'role') {
            addRoleValidation?.setFieldValue('areas', undefined);
            addRoleValidation?.setFieldValue('regions', undefined);
            const selectedOption = e.target.value;
            const role = selectedOption?.value?.toLowerCase();
            if (!role) return;

            setSelectedRole(role);
            const privileges: string[] = rolePrivilegesMap[role] || [];

            const baseFields = addRoleFormSchema.filter((item: any) => item.inputType !== 'checkbox');
            const privilegeCheckboxes = privileges.map((priv: any) => ({
                label1: priv.label1,
                value: priv?.value,
                inputType: 'checkbox',
                type: 'checkbox',
                checked: false,
                mandatory: false,
                isVisible: true,
                lg1: 12
            }));

            // Reset privilege checkboxes in form state
            privilegeCheckboxes.forEach((priv: any) => {
                addRoleValidation?.setFieldValue(priv.value, false);
            });

            setPrivilege(false);

            // also empty the options list present in the regions, areas, mines
            addRoleFormSchema?.forEach((schema: any) => {
                if (['regions', 'areas', 'mines']?.includes(schema?.value?.toLowerCase())) {
                    schema.options = [];
                }
            });

            const updatedSchema = [...baseFields, ...privilegeCheckboxes].map((field: any) => {
                const value = field.value;

                if (['admin', 'corporate nodal officer'].includes(role)) {
                    if (['regions', 'areas', 'mines'].includes(value)) {
                        return { ...field, isVisible: false, mandatory: false };
                    } else if (value === 'role') {
                        return { ...field, isVisible: true, mandatory: true };
                    } else {
                        return { ...field, isVisible: true, mandatory: false };
                    }
                }

                if (role === 'nodal officer') {
                    if (value === 'regions') {
                        return { ...field, isVisible: true, mandatory: true };
                    } else if (value === 'areas') {
                        return { ...field, isVisible: false, mandatory: true };
                    } else if (value === 'role') {
                        return { ...field, isVisible: true, mandatory: true };
                    } else if (value === 'mines') {
                        return { ...field, isVisible: false, mandatory: false };
                    } else {
                        return { ...field, isVisible: true, mandatory: false };
                    }
                }

                if (role === 'user') {
                    if (value === 'regions') {
                        return { ...field, isVisible: true, mandatory: true };
                    } else if (value === 'areas') {
                        return { ...field, isVisible: false, mandatory: true };
                    } else if (value === 'role') {
                        return { ...field, isVisible: true, mandatory: true };
                    } else if (value === 'mines') {
                        return { ...field, isVisible: false, mandatory: false };
                    } else {
                        return { ...field, isVisible: true, mandatory: false };
                    }
                }

                return field;
            });

            setAddRoleFormSchema(updatedSchema);

            if (['nodal officer', 'user'].includes(role)) {
                getRegions();
            }
        } else if (target === 'regions') {
            const selectedRegions = e.target.value;

            if (!selectedRegions || selectedRegions.length === 0) {
                // Only clear everything when all regions are removed
                addRoleValidation?.setFieldValue('areas', undefined);
                addRoleValidation?.setFieldValue('mines', undefined);
                const clearedSchema = addRoleFormSchema.map((schema: any) => {
                    if (['areas', 'mines'].includes(schema?.value?.toLowerCase())) {
                        return { ...schema, options: [], isVisible: false };
                    }
                    return schema;
                });
                setAddRoleFormSchema(clearedSchema);
                return;
            }

            const currentRole = addRoleValidation?.values?.role?.value?.toLowerCase();
            const previousAreas = addRoleValidation?.values?.areas || [];
            const previousMines = addRoleValidation?.values?.mines || [];

            // If all available regions are selected, fetch all areas without a region filter
            const regionSchema = addRoleFormSchema.find((s: any) => s?.value === 'regions');
            const allRealRegions = (regionSchema?.options || []).filter((o: any) => o?.value !== '__select_all__');
            const isAllRegionsSelected = allRealRegions.length > 0 && selectedRegions.length === allRealRegions.length;

            const selectedRegionRefs = selectedRegions.map((r: any) => r?.value);

            const fetchRegionRefs = isAllRegionsSelected ? null : selectedRegionRefs;
            getAreas(currentRole, fetchRegionRefs).then((areaOptions: any[]) => {
                // Preserve previously selected areas that still exist in the new area options
                const validAreaRefs = areaOptions.map((a: any) => a?.areaRef || a?.value);
                const retainedAreas = previousAreas.filter((a: any) =>
                    validAreaRefs.includes(a?.areaRef || a?.value)
                );
                addRoleValidation?.setFieldValue('areas', retainedAreas.length > 0 ? retainedAreas : undefined);

                // Preserve previously selected mines that belong to retained areas
                if (currentRole === 'user' && retainedAreas.length > 0) {
                    const retainedAreaRefs = retainedAreas.map((a: any) => a?.areaRef || a?.value);
                    const retainedMines = previousMines.filter((m: any) =>
                        retainedAreaRefs.includes(m?.areaId)
                    );
                    addRoleValidation?.setFieldValue('mines', retainedMines.length > 0 ? retainedMines : undefined);

                    // Re-fetch mine options for retained areas
                    getMines(retainedAreaRefs);
                } else {
                    addRoleValidation?.setFieldValue('mines', undefined);
                    setAddRoleFormSchema((prev: any) => prev.map((schema: any) => {
                        if (schema?.value === 'mines') {
                            return { ...schema, options: [], isVisible: false };
                        }
                        return schema;
                    }));
                }
            });
        } else if (target === 'areas') {
            const selectedAreas = e.target.value;
            const currentRole = addRoleValidation?.values?.role?.value?.toLowerCase();

            const areaRefs = selectedAreas?.map((area: any) => area?.areaRef);
            if (currentRole === 'user') {
                const previousMines = addRoleValidation?.values?.mines || [];
                getMines(areaRefs).then((mineOptions: any[]) => {
                    // Retain previously selected mines that still exist in the new mine options
                    const validMineRefs = mineOptions.map((m: any) => m?.mineRef || m?.value);
                    const retainedMines = previousMines.filter((m: any) =>
                        validMineRefs.includes(m?.mineRef || m?.value)
                    );
                    addRoleValidation?.setFieldValue('mines', retainedMines.length > 0 ? retainedMines : undefined);
                });
            }
        }
    };

    const getMines = (areaRefs: any, roleDetails?: any): Promise<any[]> => {
        const payLoad = {
            search: JSON.stringify({ areaId: areaRefs?.join(',') })
        };
        setLoading(true);
        return api.get(url.GET_MINES, { params: payLoad })
            .then((res: any) => {
                if (res?.status?.toLowerCase() === 'success') {
                    const mineOptions = res?.data?.data.map((item: any) => ({
                        ...item,
                        label: item?.mineName,
                        value: item?.mineRef
                    }));

                    if (roleDetails !== undefined && Object.keys(roleDetails)?.length > 0) {
                        addRoleValidation?.setFieldValue(
                            'mines',
                            roleDetails?.minesData !== undefined && roleDetails?.minesData?.length > 0
                                ? roleDetails?.minesData?.map((mine: any) => ({ ...mine, value: mine?.mineRef, label: mine?.mineName }))
                                : undefined
                        );
                    }
                    const mineOptionsWithSelectAll = [{ value: '__select_all__', label: 'Select All' }, ...mineOptions];
                    // Inject mine options into the form schema
                    setAddRoleFormSchema((prev: any) => prev.map((schema: any) => {
                        if (schema?.value === 'mines') {
                            return {
                                ...schema,
                                isVisible: true,
                                mandatory: false,
                                options: mineOptionsWithSelectAll
                            };
                        }
                        return schema;
                    }));
                    setLoading(false);
                    return mineOptions;
                } else {
                    setLoading(false);
                    return [];
                }
            })
            .catch(() => { setLoading(false); return []; });
    };

    const getRegions = (existingAreas?: any[], existingAreaRefs?: string[]) => {
        setLoading(true);
        api.get(url.GET_REGION, { params: { search: JSON.stringify({ active: 'true' }) } })
            .then((res: any) => {
                if (res?.status?.toLowerCase() === 'success') {
                    const regionDataList = res?.data?.data || [];
                    const regionOptions = [
                        { value: '__select_all__', label: 'Select All' },
                        ...regionDataList.map((item: any) => ({
                            ...item,
                            label: item?.regionName,
                            value: item?.regionRef
                        }))
                    ];
                    setAddRoleFormSchema((prev: any) => prev.map((schema: any) => {
                        if (schema?.value === 'regions') {
                            return { ...schema, options: regionOptions };
                        }
                        return schema;
                    }));

                    // Edit mode: derive regions from loaded area options (which carry regionId from the area collection)
                    if (existingAreas && existingAreas.length > 0 && existingAreaRefs && existingAreaRefs.length > 0) {
                        const allRegionIds = existingAreas
                            .filter((a: any) => existingAreaRefs.includes(a?.areaRef || a?.value))
                            .map((a: any) => a?.regionId)
                            .filter(Boolean);
                        const regionIds = allRegionIds.filter((id: string, idx: number) => allRegionIds.indexOf(id) === idx);
                        const matchedRegions = regionDataList
                            .filter((r: any) => regionIds.includes(r?.regionRef))
                            .map((r: any) => ({ ...r, label: r?.regionName, value: r?.regionRef }));
                        if (matchedRegions.length > 0) {
                            addRoleValidation?.setFieldValue('regions', matchedRegions);

                            // Filter area options to only show areas belonging to the selected regions
                            const filteredAreas = existingAreas.filter((a: any) => regionIds.includes(a?.regionId));
                            const filteredAreasWithSelectAll = [{ value: '__select_all__', label: 'Select All' }, ...filteredAreas];
                            setAddRoleFormSchema((prev: any) => prev.map((schema: any) => {
                                if (schema?.value === 'areas') {
                                    return { ...schema, isVisible: true, options: filteredAreasWithSelectAll };
                                }
                                return schema;
                            }));
                        }
                    }

                    setLoading(false);
                } else {
                    setLoading(false);
                }
            })
            .catch(() => setLoading(false));
    };

    const getAreas = (role?: any, regionRefs?: string[] | null): Promise<any[]> => {
        setModelLoading(true);
        const fetchAll = !regionRefs || regionRefs.length === 0;
        const fetchPromise: Promise<any[]> = fetchAll
            ? api.get(url.GET_AREA, { params: { search: JSON.stringify({ active: 'true' }) } }).then((res: any) => [res])
            : Promise.all(
                regionRefs.map((regionRef: string) =>
                    api.get(url.GET_AREA, { params: { search: JSON.stringify({ active: 'true', regionId: regionRef }) } })
                )
            );

        return fetchPromise
            .then((responses: any[]) => {
                const allData = responses
                    .filter((res: any) => res?.status?.toLowerCase() === 'success')
                    .flatMap((res: any) => res?.data?.data || []);

                // Deduplicate by areaRef
                const seenAreaRefs: string[] = [];
                const uniqueData = allData.filter((item: any) => {
                    if (seenAreaRefs.indexOf(item.areaRef) !== -1) return false;
                    seenAreaRefs.push(item.areaRef);
                    return true;
                });

                let areaOptions: any[];
                if (role?.toLowerCase() === 'user') {
                    areaOptions = uniqueData
                        .filter((item: any) => item?.mineCount > 0)
                        .map((item: any) => ({ ...item, label: item?.areaName, value: item?.areaRef }));
                } else {
                    areaOptions = uniqueData.map((item: any) => ({ ...item, label: item?.areaName, value: item?.areaRef }));
                }

                const areaOptionsWithSelectAll = [{ value: '__select_all__', label: 'Select All' }, ...areaOptions];

                setAddRoleFormSchema((prev: any) => prev.map((schema: any) => {
                    if (schema?.value === 'areas') {
                        return { ...schema, isVisible: true, options: areaOptionsWithSelectAll };
                    }
                    return schema;
                }));
                setModelLoading(false);
                return areaOptions;
            })
            .catch(() => { setModelLoading(false); return []; });
    };

    const atleastOnePrivilege = () => {
        return addRoleFormSchema
            .filter((item: any) => item.inputType === 'checkbox' && item.isVisible)
            .some((priv: any) => addRoleValidation?.values?.[priv.value]);
    };

    const roleModelBody = () => {
        return (
            <div className="heightPer-50">
                <Row>
                    <Col lg={6}>
                        <Row>
                            {addRoleFormSchema?.length > 0 &&
                                addRoleFormSchema.map((schema: any, index: number) => (
                                    <Col key={index} lg={schema?.lg1}>
                                        {schema?.isVisible && modelRenderItems(schema, addRoleValidation)}
                                    </Col>
                                ))}
                        </Row>
                    </Col>
                </Row>
            </div>
        );
    };

    const handleAddRoleClick = () => {
        setIsRoleModelOpen(true);
        setModeOfRole('add');
        setPrivilege(false);
        // enable the role field
        addRoleValidation?.resetForm();

        // Get already assigned role names to filter them out (normalize underscores to spaces)
        const assignedRoleNames = (rolesData || []).map((r: any) => r?.roleName?.toLowerCase()?.replaceAll('_', ' '));
        const allRoleOptions = ADMIN_ADD_ROLE_FORMSCHEMA?.find((s: any) => s?.value === 'role')?.options || [];
        const availableRoleOptions = allRoleOptions.filter(
            (opt: any) => !assignedRoleNames.includes(opt?.value?.toLowerCase())
        );

        addRoleFormSchema?.forEach((schema: any) => {
            if (schema?.value?.toLowerCase() === 'role') {
                schema.disabled = false;
                schema.isVisible = true;
                schema.mandatory = true;
                schema.options = availableRoleOptions;
            } else if (['regions', 'areas', 'mines']?.includes(schema?.value?.toLowerCase())) {
                schema.options = [];
                schema.isVisible = false;
                schema.mandatory = false;
            } else {
                schema.isVisible = false;
                schema.mandatory = false;
            }
        });
    };

    const handleEdit = (row: any) => {
        // open the model
        // based on the role implement as same as the adding
        setModeOfRole('edit');
        setIsRoleModelOpen(true);
        const roleDetails = row?.original;

        const role = roleDetails?.roleName?.toLowerCase()?.replaceAll('_', ' ');

        if (['nodal officer', 'user'].includes(role)) {
            addRoleValidation?.setFieldValue(
                'areas',
                roleDetails?.areasData?.map((item: any) => ({ ...item, value: item?.areaRef, label: item?.areaName }))
            );
        }
        if (role === 'user') {
            addRoleValidation?.setFieldValue(
                'mines',
                roleDetails?.minesData?.map((item: any) => ({ ...item, value: item?.mineRef, label: item?.mineName }))
            );
        }

        setSelectedRole(role);

        const privileges: string[] = rolePrivilegesMap[role] || [];

        const baseFields = addRoleFormSchema.filter((item: any) => item.inputType !== 'checkbox');
        const privilegeCheckboxes = privileges.map((priv: any) => ({
            label1: priv.label1,
            value: priv?.value,
            inputType: 'checkbox',
            type: 'checkbox',
            checked: false,
            mandatory: false,
            isVisible: true,
            lg1: 12
        }));

        // Reset privilege checkboxes in form state
        privilegeCheckboxes.forEach((priv: any) => {
            addRoleValidation?.setFieldValue(priv.value, false);
        });

        privilegeCheckboxes.forEach((priv: any) => {
            addRoleValidation?.setFieldValue(priv.value, roleDetails?.privileges?.includes(priv?.value));
        });

        addRoleValidation?.setFieldValue('role', {
            value: roleDetails?.roleName,
            label: roleDetails?.roleName?.[0]?.toUpperCase() + roleDetails?.roleName?.slice(1),
            id: roleDetails?.roleId
        });

        // also empty the options list present in the regions, areas, mines
        addRoleFormSchema?.forEach((schema: any) => {
            if (['regions', 'areas', 'mines']?.includes(schema?.value?.toLowerCase())) {
                schema.options = [];
            }
        });

        const updatedSchema = [...baseFields, ...privilegeCheckboxes].map((field: any) => {
            const value = field.value;

            if (['admin', 'corporate nodal officer'].includes(role)) {
                if (['regions', 'areas', 'mines'].includes(value)) {
                    return { ...field, isVisible: false, mandatory: false };
                } else if (value === 'role') {
                    return { ...field, isVisible: true, mandatory: true, disabled: true };
                } else {
                    return { ...field, isVisible: true, mandatory: false };
                }
            }

            if (role === 'nodal officer') {
                if (value === 'regions') {
                    return { ...field, isVisible: true, mandatory: true };
                } else if (value === 'areas') {
                    return { ...field, isVisible: true, mandatory: true };
                } else if (value === 'role') {
                    return { ...field, isVisible: true, mandatory: true, disabled: true };
                } else if (value === 'mines') {
                    return { ...field, isVisible: false, mandatory: false };
                } else {
                    return { ...field, isVisible: true, mandatory: false };
                }
            }

            if (role === 'user') {
                if (value === 'regions') {
                    return { ...field, isVisible: true, mandatory: true };
                } else if (value === 'areas') {
                    return { ...field, isVisible: true, mandatory: true };
                } else if (value === 'role') {
                    return { ...field, isVisible: true, mandatory: true, disabled: true };
                } else if (value === 'mines') {
                    return { ...field, isVisible: true, mandatory: false };
                } else {
                    return { ...field, isVisible: true, mandatory: false };
                }
            }

            return field;
        });

        setAddRoleFormSchema(updatedSchema);

        if (['nodal officer', 'user'].includes(role)) {
            const existingAreaRefs = roleDetails?.areasData?.map((a: any) => a?.areaRef) || [];
            // Fetch all areas first (area documents carry regionId); then derive and pre-select regions
            getAreas(role, null).then((areaOptions) => {
                getRegions(areaOptions, existingAreaRefs);
            });
        }

        if (role === 'user') {
            const selectedAreas = roleDetails?.areasData?.map((area: any) => area?.areaRef);
            if (selectedAreas?.length > 0) {
                getMines(selectedAreas, roleDetails);
            }
        }
    };

    const handleDeleteRole = (row: any) => {
        const roleId = row?.original?.roleId;
        const roleName = row?.original?.roleName;

        setRolesData((privRoles: any) =>
            privRoles?.filter(
                (roleItem: any) => !(roleItem.roleId === roleId && roleItem?.roleName?.toLowerCase()?.replaceAll('_', ' ') === roleName?.toLowerCase()?.replaceAll('_', ' '))
            )
        );
        setIsDeleteModelOpen(false);
        toast.success('Role Deleted Successfully');
    };

    return (
        <React.Fragment>
            <div className="page-content">
                {loading && <Loader />}
                <BreadCrumb
                    subTitle={[
                        { label: 'User Management', link: '/user-management' },
                        { label: 'All User', link: '/user-management' },
                        { label: 'Edit User', link: '/user-management' }
                    ]}
                />
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <Row>
                                        {formSchema?.length > 0 &&
                                            formSchema.map((field: any, index: number) => {
                                                return (
                                                    <React.Fragment key={index}>
                                                        {field.isVisible && (
                                                            <Col lg={field?.lg1}>{renderItems({ ...field }, EditUserValidation)}</Col>
                                                        )}
                                                    </React.Fragment>
                                                );
                                            })}
                                        <TableContainer
                                            columns={tableSchema}
                                            data={rolesData}
                                            loading={loading}
                                            className="custom-header-css"
                                            divClass="table-responsive table-card"
                                            tableClass="table-nowrap table-border table-centered align-middle"
                                            theadClass="light-bg-grey text-muted"
                                            isGlobalFilter={true}
                                            searchPlaceholderSize="16"
                                            addButton={true}
                                            addButtonText="Add Role"
                                            handleAddNew={handleAddRoleClick}
                                            searchPlaceHolder={'...'}
                                            handleEdit={handleEdit}
                                            handleDelete={(row: any) => {
                                                setSelectedRow(row);
                                                setIsDeleteModelOpen(true);
                                            }}
                                            hidePagination={false}
                                            disabledbtn={!EditUserValidation.isValid || !EditUserValidation.dirty}
                                        />
                                    </Row>

                                    <Row>
                                        <div className="d-flex gap-2 justify-content-end mt-3 mb-2">
                                            <Button
                                                outline
                                                className="w-sm btn-outline-success border-2 br-6 font-weight-600 font-size-14"
                                                color=""
                                                data-bs-dismiss="modal"
                                                onClick={() => props?.router?.navigate(-1)}
                                            >
                                                {'Cancel'}
                                            </Button>
                                            <button
                                                type="submit"
                                                className="btn w-sm btn-primary br-6 text-secondary font-weight-600 font-size-14"
                                                disabled={
                                                    loading ||
                                                    !EditUserValidation.isValid ||
                                                    !EditUserValidation.dirty ||
                                                    rolesData?.length === 0
                                                }
                                                onClick={() => EditUserValidation?.handleSubmit()}
                                            >
                                                {'Update'}
                                            </button>
                                        </div>
                                    </Row>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                    {isRoleModelOpen && (
                        <CommonModal
                            headerClass={'bg-primary text-secondary'}
                            size={'lg'}
                            cancelText={'Cancel'}
                            loading={modelLoading}
                            saveText={modeOfRole?.toLowerCase() === 'edit' ? 'Update' : 'Save'}
                            isHeader={true}
                            // disabled={!addRoleValidation?.isValid || !addRoleValidation?.dirty || atleastOnePrivilege()}
                            disabled={!addRoleValidation?.isValid || !addRoleValidation?.dirty || !atleastOnePrivilege()}
                            show={isRoleModelOpen}
                            handleModalBody={() => roleModelBody()}
                            handleClick={addRoleValidation?.handleSubmit}
                            onCloseClick={() => {
                                setIsRoleModelOpen(false);
                                addRoleValidation?.resetForm();
                                setPrivilege(false);
                            }}
                            modalheader={modeOfRole?.toLowerCase() === 'edit' ? 'Edit Role' : 'Add Role'}
                            hideSaveButton={false}
                            hideCancelButton={false}
                        />
                    )}

                    {isDeleteModelOpen && (
                        <DeleteModal
                            show={isDeleteModelOpen}
                            onCloseClick={() => setIsDeleteModelOpen(false)}
                            onDeleteClick={() => handleDeleteRole(selectedRow)}
                        />
                    )}
                </Container>
            </div>
        </React.Fragment>
    );
};
export default withRouter(EditUser);